"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.string.trim");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));

var _Button = _interopRequireDefault(require("@arcblock/ux/lib/Button"));

var _Icon = _interopRequireDefault(require("@arcblock/ux/lib/Icon"));

var _Util = require("@arcblock/ux/lib/Util");

var _session = require("../Contexts/session");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/**
 * DID:Connect component that can be used to protected some content with login
 * User can specify a preview of the content
 */


function LoginProtected(props) {
  var newProps = (0, _Util.mergeProps)(props, LoginProtected, []);

  var btnText = newProps.btnText,
      btnSize = newProps.btnSize,
      btnColor = newProps.btnColor,
      btnVariant = newProps.btnVariant,
      btnClass = newProps.btnClass,
      content = newProps.content,
      preview = newProps.preview,
      children = newProps.children,
      unlockTip = newProps.unlockTip,
      unlockMaskSize = newProps.unlockMaskSize,
      rest = _objectWithoutProperties(newProps, ["btnText", "btnSize", "btnColor", "btnVariant", "btnClass", "content", "preview", "children", "unlockTip", "unlockMaskSize"]);

  var _ref = props.session || {},
      error = _ref.error,
      user = _ref.user,
      loading = _ref.loading,
      login = _ref.login;

  if (user) {
    if (content) {
      return typeof content === 'function' ? content({
        user: user
      }) : content;
    }

    return typeof children === 'function' ? children({
      user: user
    }) : children;
  }

  var button = _react["default"].createElement(_Button["default"], {
    onClick: login,
    variant: btnVariant,
    color: btnColor,
    className: "unlock-button ".concat(btnClass).trim(),
    disabled: loading,
    size: btnSize
  }, btnText);

  return _react["default"].createElement(Container, Object.assign({
    maskSize: unlockMaskSize
  }, rest), typeof preview === 'function' ? preview() : preview, _react["default"].createElement("div", {
    className: "unlock-container"
  }, _react["default"].createElement("div", {
    className: "unlock-tip"
  }, _react["default"].createElement(_Icon["default"], {
    name: "exclamation-circle",
    className: "unlock-icon",
    color: "#4e6af6",
    size: 16
  }), _react["default"].createElement(_Typography["default"], {
    component: "span",
    className: "unlock-tip-content"
  }, unlockTip)), error ? _react["default"].createElement(_Tooltip["default"], {
    title: "Error: ".concat(error)
  }, button) : button));
}

LoginProtected.propTypes = {
  session: _propTypes["default"].object,
  children: _propTypes["default"].any,
  content: _propTypes["default"].any,
  // can be component tree or string
  preview: _propTypes["default"].any,
  // can be component tree or string
  unlockTip: _propTypes["default"].string,
  btnText: _propTypes["default"].string,
  btnSize: _propTypes["default"].string,
  btnColor: _propTypes["default"].string,
  btnVariant: _propTypes["default"].string,
  btnClass: _propTypes["default"].string,
  unlockMaskSize: _propTypes["default"].number
};
LoginProtected.defaultProps = {
  session: {},
  children: null,
  content: null,
  preview: null,
  unlockTip: 'This content is only for ABT Wallet users, please sign in to unlock remaining content',
  btnText: 'Sign In',
  btnSize: 'medium',
  btnColor: 'primary',
  btnVariant: 'outlined',
  btnClass: 'unlock-button',
  unlockMaskSize: 90
};
LoginProtected.contextTypes = {
  session: _propTypes["default"].object
};

var Container = _styledComponents["default"].div.withConfig({
  displayName: "LoginProtected__Container",
  componentId: "sc-6crakq-0"
})([".unlock-container{position:relative;&:before{content:'';background:linear-gradient(transparent,#fff) left repeat;display:block;position:absolute;top:-", "px;left:0;width:100%;height:", "px;}.unlock-tip{display:flex;justify-content:flex-start;align-items:center;margin:20px 0;.unlock-icon{margin-right:8px;}.unlock-tip-content{color:#4e6af6;font-weight:500;}}}"], function (props) {
  return props.maskSize;
}, function (props) {
  return props.maskSize;
});

var _default = (0, _session.withDidSession)(LoginProtected);

exports["default"] = _default;